export const SET_SHOP_DOMAIN = (state, domain) => {
  state.shopDomain = domain;
};
